import { send } from 'server';

export const acceptBonusMessage = ({ accept, dialogId }) => send({
    ID: 31022,
    description: 'Bonus Message Accept',
    responses: [31023, 31024],
    accept,
    bonusIdentifier: dialogId
});
